import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateIotTimer, IotTimer, IotTimerListResponse, IotTimerQueryParams, UpdateIotTimer } from '@frontend/iot/types';

export class IotTimerClient extends APIClient {
    public static readonly endpoint = '/iot-api/v1';

    public static async fetchTimers(queryParams?: ApiQueryParams<IotTimerQueryParams>): Promise<IotTimerListResponse> {
        return await this.apiPaginated<IotTimerListResponse, IotTimerQueryParams>(`${this.endpoint}/timers`, queryParams);
    }

    public static async fetchStartedTimers(queryParams?: ApiQueryParams<IotTimerQueryParams>): Promise<IotTimerListResponse> {
        return await this.apiPaginated<IotTimerListResponse, IotTimerQueryParams>(`${this.endpoint}/started-timers`, queryParams);
    }

    public static async fetchAccountIotTimers(
        accountId: string,
        iotId: string,
        queryParams?: ApiQueryParams<IotTimerQueryParams>
    ): Promise<IotTimerListResponse> {
        return await this.apiPaginated<IotTimerListResponse, IotTimerQueryParams>(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/timers`, queryParams);
    }

    public static async fetchAccountIotTimer(accountId: string, iotId: string, timerId: string): Promise<IotTimer> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/timers/${timerId}`);
        return await this.handleResponse<IotTimer>(response);
    }

    public static async postAccountIotTimer(accountId: string, iotId: string, body: CreateIotTimer): Promise<IotTimer> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/timers`, body);
        return await this.handleResponse<IotTimer>(response);
    }

    public static async patchAccountIotTimer(accountId: string, iotId: string, timerId: string, body: UpdateIotTimer): Promise<IotTimer> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/timers/${timerId}`, body);
        return await this.handleResponse<IotTimer>(response);
    }

    public static async deleteAccountIotTimer(accountId: string, iotId: string, timerId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/timers/${timerId}`);
        await this.handleVoidResponse(response);
    }
}
